import React, {FC, useState, useEffect, useRef, useLayoutEffect} from "react";
import { useTranslation } from "react-i18next";
import { icons } from "../../icons";
import {
  Container,
  SearchWrapper,
  ImgArrow,
  OptionsWrapper,
  SearchInput,
  Title,
  IconWrapper,
  Divider,
  SearchResultsContainer,
  DividerCategory,
  DropOptionsTitle,
  DropItemWrapper,
  DropOptionItem,
} from './styles'
import useDebounce from "../../hooks/useDebounce";
import { useQueryParam, StringParam } from "use-query-params";


type SearchProps = {
  variants?: any[],
}

const SearchComponent:FC<SearchProps> = ({
  variants,
}) => {
  const selectRef:any = useRef(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const shouldRestoreFocus = useRef(false)
  const [active, setActive] = useState<boolean>(false)
  const [activeResults, setActiveResults] = useState<boolean>(false)
  const [t] = useTranslation()
  const [search, setSearch] = useQueryParam('search', StringParam);
  const [searchString, setSearchString] = useState<any>(search || '')
  const debounce = useDebounce(searchString, 500)

  // Keep query param in sync when input changes (debounced)
  useEffect(() => {
    if (debounce !== search) {
      // @ts-ignore: use-query-params accepts undefined to clear
      setSearch(debounce || undefined)
    }
  }, [debounce])

  // Keep input value in sync when query param changes externally (e.g. browser back)
  useEffect(() => {
    if ((search || '') !== searchString) {
      setSearchString(search || '')
    }
  }, [search])

  // Restore focus after re-renders caused by data fetching
  useLayoutEffect(() => {
    if (shouldRestoreFocus.current && inputRef.current) {
      inputRef.current.focus()
      shouldRestoreFocus.current = false
    }
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchString(e.target.value)
    shouldRestoreFocus.current = true
  }

  const handleFocus = () => {
    setActive(true)
    shouldRestoreFocus.current = true
  }

  const handleBlur = () => {
    // Delay to allow re-render to happen first; if focus was restored, don't deactivate
    setTimeout(() => {
      if (document.activeElement !== inputRef.current) {
        setActive(false)
        shouldRestoreFocus.current = false
      }
    }, 0)
  }

  return (
    <Container>
      <SearchWrapper onClick={() => {
        setActive(true)
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }} activeResults={active} active={active} >
        <div style={{display:'flex', width:'100%', alignItems:'flex-end'}}>
          <IconWrapper>
            <img src={icons.SearchIcon}/>
            {(!searchString ) &&
              <Title>
                {t("SEARCH")}
              </Title>
            }
          </IconWrapper>
          <SearchInput
            ref={inputRef}
            autoComplete="off"
            active={active}
            onFocus={handleFocus}
            onBlur={handleBlur}
            value={searchString}
            onChange={handleChange}
          />
        </div>
      </SearchWrapper>
        {variants && variants.length > 0 &&
          <SearchResultsContainer active={activeResults}>
            <Divider active={activeResults}/>
            <OptionsWrapper style={{paddingTop:'18.5px', paddingBottom:'18.5px'}} ref={selectRef} active={activeResults}>
            {variants?.map((variant:any) => (
              <DropOptionsTitle>
                {variant?.title}
              </DropOptionsTitle>
            ))}
          </OptionsWrapper>
        </SearchResultsContainer>
      }
    </Container>
  )
}

export default SearchComponent
